import { render, staticRenderFns } from "./AttributionStatusBadge.vue?vue&type=template&id=7d797149"
import script from "./AttributionStatusBadge.vue?vue&type=script&lang=js"
export * from "./AttributionStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports